import { Profile } from '@cimpress/simple-auth-wrapper';

export const getEmailId = (profile: Profile): string => {
  return (profile['https://claims.cimpress.io/canonical_id'] ?? profile.email).toLowerCase();
};
